export default __webpack_public_path__ + "static/media/Walker's Gloves of Passing Spirits.a46f1280.jpg";